import { formatToBRL, formatToMillionBRL } from "@/utils/formatToMoney";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "components/ui/tooltip";
import { useNavigate } from "react-router-dom";
import type { IDepositStoresSummaryRow } from "src/@types/deposit-reconciliation";
import { STORE_RECONCILIATION_STATUS } from "../../constants/status";
import { STORE_ACTION_LABELS } from "../constants/action-labels";
import { useDepositStoresFilterState } from "../ducks/filter/hooks/filter-state";

function actionLabelOf(store: IDepositStoresSummaryRow): string {
  if (store.status === STORE_RECONCILIATION_STATUS.FECHADO) {
    return STORE_ACTION_LABELS.VIEW;
  }
  if (store.status === STORE_RECONCILIATION_STATUS.AGUARDANDO) {
    return STORE_ACTION_LABELS.CONTINUE;
  }
  return STORE_ACTION_LABELS.RECONCILE;
}

export function ActionButton({ store }: { store: IDepositStoresSummaryRow }) {
  const navigate = useNavigate();
  const filterState = useDepositStoresFilterState();
  const { filters } = filterState || { filters: {} };

  const label = actionLabelOf(store);

  const handleClick = () => {
    const params = new URLSearchParams();
    if (filters.periodStart) params.append("periodStart", filters.periodStart);
    if (filters.periodEnd) params.append("periodEnd", filters.periodEnd);
    if (store.status === STORE_RECONCILIATION_STATUS.FECHADO) {
      params.append("includeReconciled", "true");
    }
    navigate(`/conciliacao/depositos/${store.storeCode}?${params.toString()}`);
  };

  return (
    <button
      onClick={handleClick}
      className="text-[#5577b9] underline hover:brightness-75"
    >
      {label}
    </button>
  );
}

export function MoneyCell({ value }: { value: number }) {
  return (
    <div className="text-right">
      <TooltipProvider>
        <Tooltip>
          <TooltipTrigger asChild>
            <p className="cursor-pointer">{formatToMillionBRL(value)}</p>
          </TooltipTrigger>
          <TooltipContent className="bg-[#141414] text-white text-center">
            <p>{formatToBRL(value)}</p>
          </TooltipContent>
        </Tooltip>
      </TooltipProvider>
    </div>
  );
}

export function DivergenceCell({ value }: { value: number }) {
  const color = value === 0 ? "#00AC4F" : value > 0 ? "#5577b9" : "#DC2626";
  return (
    <div className="text-right" style={{ color }}>
      <TooltipProvider>
        <Tooltip>
          <TooltipTrigger asChild>
            <p className="cursor-pointer font-medium">{formatToBRL(value)}</p>
          </TooltipTrigger>
          <TooltipContent className="bg-[#141414] text-white text-center">
            <p>{formatToBRL(value)}</p>
          </TooltipContent>
        </Tooltip>
      </TooltipProvider>
    </div>
  );
}
